import React from 'react';

import { ChangeHandler } from 'src/presentation/components/pages/integrations/types';
import CompactSection from 'src/presentation/components/pages/integrations/editorComponents/CompactSection';
import Dropdown from 'src/presentation/components/forms/Dropdown';
import MultiselectChips from 'src/presentation/components/forms/MultiselectChips';
import { WrappedField } from 'src/presentation/components/pages/integrations/editorComponents/EditorFields';
import { Row } from 'src/presentation/components/forms/Layout';
import { SUPPORTED_ENTITIES, SUPPORTED_REGIONS } from 'src/presentation/components/pages/integrations/constants';

function renderAwsEventBridgeConfiguration(onChange: (attr: string) => ChangeHandler): JSX.Element {
  return (
    <>
      <CompactSection
        description={`The Gladly-AWS EventBridge integration enables you to stream events to your AWS Account.`}
      >
        <Row>
          <WrappedField
            attr="name"
            label="Name"
            placeholder="App Name"
            description="This is the name that will be displayed throughout Gladly"
            data-aid="awseventbridge-integration-name"
            autoFocus={true}
            onChange={onChange('name')}
          />
        </Row>

        <Row>
          <WrappedField
            attr="customConfigurations.awsAccountId"
            label="AWS Account ID"
            data-aid="aws-account-id"
            description="Enter the AWS Account ID you want to send data"
            onChange={onChange('customConfigurations.awsAccountId')}
          />
        </Row>
        <Row>
          <Dropdown
            autoFocus
            attr="customConfigurations.region"
            data-aid="awseventbridge-region"
            description="Select the AWS region to send data"
            label="AWS Region"
            options={SUPPORTED_REGIONS}
            placeholder="Select Region"
            searchable
          />
        </Row>
        <Row>
          <MultiselectChips
            attr="customConfigurations.entityTypes"
            data-aid="awseventbridge-entityTypes"
            label="Entity Types"
            description="Select the event type you want to stream"
            options={SUPPORTED_ENTITIES}
            onChange={onChange('customConfigurations.entityTypes')}
          />
        </Row>
      </CompactSection>
    </>
  );
}

export default renderAwsEventBridgeConfiguration;
